module.exports = __webpack_public_path__ + "static/img/14000073.fcec7180.png";